var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.44444C22 7.71608 21.3324 8.86298 20.2624 9.67309C20.6671 10.6218 20.8889 11.6524 20.8889 12.7299C20.8889 17.4285 16.6701 21.2376 11.4661 21.2376C9.70737 21.2376 8.06122 20.8026 6.6524 20.0452C5.88803 20.8975 4.65766 21.5367 2.22292 21.9964C2.01361 22.0359 1.91264 21.7432 2.09484 21.6326C3.53224 20.7594 4.20676 19.8951 4.36296 18.3203C2.91828 16.8253 2.04321 14.8698 2.04321 12.7299C2.04321 8.03123 6.26196 4.22222 11.4661 4.22222C11.5212 4.22222 11.5763 4.22265 11.6312 4.2235C12.5916 2.89435 14.3874 2 16.4444 2C19.5127 2 22 3.98985 22 6.44444ZM8.5 12.5C8.5 11.9477 8.05229 11.5 7.5 11.5C6.94772 11.5 6.5 11.9477 6.5 12.5C6.5 13.0523 6.94772 13.5 7.5 13.5C8.05229 13.5 8.5 13.0523 8.5 12.5ZM12.5 12.5C12.5 11.9477 12.0523 11.5 11.5 11.5C10.9477 11.5 10.5 11.9477 10.5 12.5C10.5 13.0523 10.9477 13.5 11.5 13.5C12.0523 13.5 12.5 13.0523 12.5 12.5ZM15.5 13.5C16.0523 13.5 16.5 13.0523 16.5 12.5C16.5 11.9477 16.0523 11.5 15.5 11.5C14.9477 11.5 14.5 11.9477 14.5 12.5C14.5 13.0523 14.9477 13.5 15.5 13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble42);
export default __webpack_public_path__ + "static/media/speech-bubble-42.249593278398f83ea24034bf22abdd51.svg";
export { ForwardRef as ReactComponent };